module.exports = __webpack_public_path__ + "img/14.74be76fe.jpg";